import { CourseStatusTypes } from '../../types/curricularAdvancementTypes';
import { ValidationType } from './validation-type';

export function getColor(state?: CourseStatusTypes | ValidationType) {
  const ValidationTypeColors: Record<
    CourseStatusTypes | ValidationType,
    string
  > = {
    // CourseEnrollmentStates
    A: '#adf7a8',
    P: '#abcce9',
    R: '#ffa19d',
    V: '#BFACE2',
    E: '#fff784',
    VS: '#BFACE2',
    VV: '#BFACE2',
    // CourseValidationType
    [ValidationType.Internal]: '#F8C3FF',
    [ValidationType.RAP]: '#AFF4F1',
    [ValidationType.External]: '#FFCB8E',
  };

  if (!state) {
    return undefined;
  }
  return ValidationTypeColors[state] ?? undefined;
}
